import { render } from "./TherapyFormEdit.vue?vue&type=template&id=5f42b2b3"
import script from "./TherapyFormEdit.vue?vue&type=script&lang=js"
export * from "./TherapyFormEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__